import { type UserType } from '@/schemas/auth-user';

// User types whose home page lives in this React app.
// Source: HubsService.HOME_ROUTES in Angular routes /dash/coordenador → /home/coordenador.
export const REACT_HOME_USER_TYPES = new Set<UserType>(['COORDENADOR_ESCOLA', 'COORDENADOR_TURMA', 'COORDENADOR_SAAS']);

export const REACT_HOME_ROUTE = '/home/coordenador';

// Angular-side home paths for all other user types.
// Source: HubsService.HOME_ROUTES in the Angular app.
export const ANGULAR_HOME_PATH_BY_USER_TYPE: Partial<Record<UserType, string>> = {
  SUPER_ADMIN: '/dash/admin',
  ADMIN: '/dash/admin',
  PROFESSOR: '/correcao',
  CORRETOR_SAAS: '/correcao',
  ALUNO: '/redacao/lista',
  ALUNO_B2C: '/redacao/lista',
  ASSESSOR: '/dash/assessor',
};
